"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emptyData = {
    name: '',
    dimension: '',
    symbol: '',
    superImprovement: false,
    metrics: [],
};
class Category {
    constructor(data = emptyData) {
        this.name = data.name || '';
        this.dimension = data.dimension || '';
        this.symbol = data.symbol || '';
        this.superImprovement = data.superImprovement || false;
        this.metrics = data.metrics || [];
    }
}
exports.default = Category;
